/*
 * Filename: CQVisibleRule.componect.tsx
 * Description: Component for visible rule.
 */

import { CQAppConstant } from '../../../app-constants';
import { BaseRuleController } from '../base-rule.controller';

export class VisibleRuleRowActionsController extends BaseRuleController<any> {

    public ruleJSON = {};

    constructor(ruleObject: any) {
        super();
        this.formRuleJson(ruleObject);
    }
    /**
     * @private
     * @memberof VisibleRuleRowActionsController
     */
    private formRuleJson = (ruleObject: any) => {
        if (ruleObject.isVisible === 'false') {
            return this.ruleJSON = {
                [CQAppConstant.TOGGLE_ACTION_RULE_TYPES[2]]: false
            };
        } else {
            const rules: any = this.formRuleFilter(ruleObject.complexLogicQuery, ruleObject.addedCriterias);
            return this.ruleJSON = {
                [CQAppConstant.TOGGLE_ACTION_RULE_TYPES[2]]: rules.filterCriteria
            };
        }

    }

    /**
     * @memberof VisibleRuleRowActionsController
     */
    public formRuleFilter = (complexLogic: string, addedCriterias: any[]) => {
        const filterCriteria = this.formFilterString(complexLogic, addedCriterias);
        const fieldsArray: string[] = [];
        addedCriterias.forEach((criteria: any) => {
            fieldsArray.push(criteria.field);
            if (criteria.isDynamic) {
                fieldsArray.push(criteria.compareTo);
            }
        });
        return {
            fieldsArray,
            filterCriteria
        };
    }
    
    protected generateFilterString(criterias: any[]) {
        const criteriaFilterString: string[] = [];
        criterias.forEach((criteria: any) => {
            const operator = (criteria.operator !== CQAppConstant.EXISTS
                && criteria.operator !== CQAppConstant.ISEMPTY) ? criteria.operator : '';
            if (criteria.isDynamic && operator !=='') {
                criteriaFilterString.push(` ${criteria.fieldType==='Child' ? CQAppConstant.RECORD : CQAppConstant.PARENT}${criteria.field}${criteria.fieldType==='Child' ? '' : CQAppConstant.PARENT_FIELD_VALUE} ${operator} ${criteria.compareFieldType==='Child' ? CQAppConstant.RECORD : CQAppConstant.PARENT}${criteria.compareTo}${criteria.compareFieldType==='Child' ? '' : CQAppConstant.PARENT_FIELD_VALUE}`);
            } else {
                let isNumber = false;
                if (criteria.compareTo === true || criteria.compareTo === false || criteria.compareTo === '') {
                    isNumber = false;
                } else {
                    isNumber = !isNaN(criteria.compareTo);
                }
                criteriaFilterString.push(
                    `${criteria.operator === CQAppConstant.ISEMPTY && criteria.fieldType === 'Child' ? '!' 
                    : ''}${criteria.fieldType === 'Child' ? CQAppConstant.RECORD 
                    : CQAppConstant.PARENT}${criteria.field}${criteria.fieldType === 'Child' ? '' 
                    : CQAppConstant.PARENT_FIELD_VALUE} ${operator} ${isNumber ? parseInt(criteria.compareTo) 
                    : this.covertStringIfIBooleanType(criteria.compareTo)}${criteria.operator === CQAppConstant.EXISTS && criteria.fieldType !== 'Child' ? '!== null' 
                    : ''} ${criteria.operator === CQAppConstant.ISEMPTY && criteria.fieldType !== 'Child' ? '== null' 
                    : ''} `
                );
            }
        });

        return { criteriaFilterString, referenceFieldInCriteria: [] }
    }

}



